import { bunja } from 'bunja';
import { atomWithMutation } from 'jotai-tanstack-query';

import { postAddPositionApi, postOneWayOrderApi } from '@flipster/apis/v2/trade';
import { PostAddPositionParams, PostOneWayOrderParams } from '@flipster/apis/v2/trade/types';

/**
 * Add position 액션의 mutation 레이어 (구 AddPositionModal state.ts에서 추출).
 * 페이로드 조립·IOC 토스트·segment는 모달 bunja(호출측)에 남아 있다 — 추출은 mutation만.
 * mutationKey는 기존과 byte-동일하게 유지한다(query cache/devtools 관찰 가능 표면).
 */
export const addPositionMutationsBunja = bunja(() => {
  const postAddPositionApiAtom = atomWithMutation(() => ({
    mutationKey: ['postAddPositionApi'],
    mutationFn: ({ symbol, slot, params }: { symbol: string; slot: number; params: PostAddPositionParams }) =>
      postAddPositionApi(symbol, slot, params),
  }));

  const postOneWayAddPositionApiAtom = atomWithMutation(() => ({
    mutationKey: ['postOneWayAddPositionApi'],
    mutationFn: ({ symbol, params }: { symbol: string; params: PostOneWayOrderParams }) =>
      postOneWayOrderApi(symbol, params),
  }));

  return { postAddPositionApiAtom, postOneWayAddPositionApiAtom };
});
addPositionMutationsBunja.debugLabel = 'addPositionMutationsBunja';
